import { defineMessages } from 'react-intl';

export const reviewStatisticMessages = defineMessages({
  label: {
    id: 'rating.rating-statistics.label',
    defaultMessage: `{rating, plural, one {# Stern} other {# Sterne}}`,
  },
});
